import { Controller } from "@hotwired/stimulus"

// auto-submit — submete o form ao mudar um campo, sem handler inline (CSP-safe:
// a policy tem script_src :self sem unsafe_inline, então onchange="..." no HTML
// é bloqueado). Uso: no form, data-controller="auto-submit"
// data-action="input->auto-submit#submit change->auto-submit#submit".
//
// Busca por texto (input type=search): só submete com 0 (limpou) ou >= 3
// caracteres — evita recarregar a cada letra e buscas triviais. Debounce de
// 350ms na digitação; selects (change) respondem em 50ms.
//
// O foco NÃO se perde após o submit porque o input de busca é marcado com
// data-turbo-permanent (o elemento sobrevive à troca de DOM do Turbo, mantendo
// foco e cursor nativamente). Ver o template.
//
// PRESERVAÇÃO DE SCROLL: o Turbo rola a página para o topo em toda navegação que
// não seja um page-refresh com morphing (nossa busca muda a query string, então
// não se qualifica). turbo_action="replace" só controla o histórico, não o scroll.
// Então guardamos window.scrollY em sessionStorage ANTES do submit e restauramos
// no connect seguinte (o controller re-conecta após o render do Turbo). A chave é
// por-form (pathname) para não vazar entre telas.
const MIN_SEARCH_CHARS = 3

export default class extends Controller {
  connect() {
    // Restaura a posição guardada por um submit anterior desta mesma tela.
    const key = this._scrollKey()
    const saved = sessionStorage.getItem(key)
    if (saved !== null) {
      sessionStorage.removeItem(key)
      // Restaura após o layout estabilizar (o conteúdo já foi trocado pelo Turbo).
      requestAnimationFrame(() => window.scrollTo(0, parseInt(saved, 10)))
    }
  }

  disconnect() {
    clearTimeout(this._t)
  }

  submit(event) {
    const el = event?.target
    if (el && el.type === "search") {
      const len = el.value.trim().length
      if (len > 0 && len < MIN_SEARCH_CHARS) return
    }

    const delay = event?.type === "input" ? 350 : 50
    clearTimeout(this._t)
    this._t = setTimeout(() => {
      // Guarda o scroll ATUAL logo antes de submeter, para o connect seguinte
      // restaurar (o Turbo, por padrão, subiria a página para o topo).
      sessionStorage.setItem(this._scrollKey(), String(window.scrollY))
      this.element.requestSubmit
        ? this.element.requestSubmit()
        : this.element.submit()
    }, delay)
  }

  // Chave de scroll por tela (pathname), para não restaurar posição de uma tela
  // ao chegar em outra.
  _scrollKey() {
    return `auto-submit:scroll:${window.location.pathname}`
  }
}
